import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5112bfed")

_pushScopeId("data-v-5112bfed")
const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "row g-6 mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_6 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_7 = {
  key: 3,
  class: "col-md-4"
}
const _hoisted_8 = {
  key: 4,
  class: "col-md-4"
}
const _hoisted_9 = {
  key: 0,
  class: "card mb-5 mb-xl-10 seq-card"
}
const _hoisted_10 = { class: "card-body pt-6 pb-0" }
const _hoisted_11 = { class: "d-flex flex-wrap account-details-stats-row" }
const _hoisted_12 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_13 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_14 = { class: "fs-2 fw-bolder" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Sponsor ID", -1)
const _hoisted_16 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_17 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_18 = { class: "fs-2 fw-bolder" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Date Of Registration", -1)
const _hoisted_20 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_21 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_22 = { class: "fs-2 fw-bolder" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "* PCP Enrollment", -1)
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_25 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_26 = { class: "fs-2 fw-bolder" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Total Purchased PCP Product", -1)
const _hoisted_28 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_29 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_30 = { class: "fs-2 fw-bolder" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Target Milestone", -1)
const _hoisted_32 = { class: "account-details-footnote" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_StatCard = _resolveComponent("StatCard")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_el_skeleton, {
        rows: 3,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loadingBalance]
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      (_ctx.pt != 'bibo' && _ctx.pt != 'ecc')
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_StatCard, {
              label: "Consolidated Balance",
              icon: "media/icons/duotone/Shopping/Wallet2.svg",
              value: _ctx.accountdetailsdata.overAllAvailableBalance,
              currencySymbol: _ctx.accountdetailsdata.currency || ''
            }, null, 8, ["value", "currencySymbol"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_StatCard, {
          label: `${_ctx.user.usid} Balance`,
          icon: "media/icons/duotone/Shopping/Money.svg",
          value: _ctx.accountdetailsdata.balance,
          currencySymbol: _ctx.accountdetailsdata.currency || ''
        }, null, 8, ["label", "value", "currencySymbol"])
      ]),
      (_ctx.pt != 'bibo' && _ctx.pt != 'ecc')
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_StatCard, {
              label: "EC Wallet",
              icon: "media/icons/duotone/Shopping/Credit-card.svg",
              value: _ctx.accountdetailsdata.ewalletbalance,
              currencySymbol: _ctx.ewalletCurrency
            }, null, 8, ["value", "currencySymbol"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.ccode === 0)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_StatCard, {
              label: "MG Pay",
              icon: "media/icons/duotone/Shopping/Wallet.svg",
              value: _ctx.accountdetailsdata.matchinpaybalance,
              currencySymbol: _ctx.accountdetailsdata.currency || ''
            }, null, 8, ["value", "currencySymbol"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.pt != 'bibo' && _ctx.pt != 'ecc')
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_StatCard, {
              label: "PGI",
              period: "Total",
              icon: "media/icons/duotone/Home/Air-ballon.svg",
              value: _ctx.accountdetailsdata.travelgc,
              currencySymbol: "",
              decimals: 0
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.pt != 'bibo' && _ctx.pt != 'ecc')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_StatCard, {
              label: "Product GC",
              period: "Total",
              icon: "media/icons/duotone/Shopping/Box2.svg",
              value: _ctx.accountdetailsdata.productgc,
              currencySymbol: "",
              decimals: 0
            }, null, 8, ["value"])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.loadingBalance && _ctx.pt != 'pcp']
    ]),
    (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.pcpdetails.spid), 1)
                ]),
                _hoisted_15
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, _toDisplayString(_ctx.formatDateMonthDayYear(_ctx.pcpdetails.regDate)), 1)
                ]),
                _hoisted_19
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcpEnrollmentFee).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                ]),
                _hoisted_23
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcp_product_total).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                ]),
                _hoisted_27
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.nextMilestone).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                ]),
                _hoisted_31
              ])
            ]),
            _createVNode("p", _hoisted_32, " * PCP Enrollment includes " + _toDisplayString(_ctx.pcpdetails.pcpEnrollmentInclusions), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})